import BlockList from 'atoms/BlockList';

import styles from './Scopes.module.css';

const Scopes: React.FC<{
  children: React.ReactNode;
}> = (props: any) => {
  const scopes =
    typeof props.children === 'string'
      ? props.children.split(',')
      : props.children.props.children.split(',');

  return (
    <div className={styles.wrapper}>
      <BlockList>{scopes}</BlockList>
    </div>
  );
};

export default Scopes;
